export const FILTER_PANEL_LOCALE = {
    filter: 'Filter',
    confirm: 'OK',
    cancel: 'Cancel',
    reset: 'Clear',
    advancedFilter: 'More Conditions',
    expand: 'Expand',
    fold: 'Fold',
    last1Month: 'LastOneMonth',
    last3Month: 'LastThreeMonth',
    last6Month: 'LastSixMonth',
    pleaseInput: 'Please input ',
    searchHistory: 'Search History',
    searchResult: 'Search Result',
    intervalFilter: 'Filter by interval',
    beginPlaceHolder: 'Minimum value',
    endPlaceHolder: 'Maximum value',
    dateBeginPlaceHolder: 'Start date',
    dateEndPlaceHolder: 'End date',
    empty: 'Reset',
    clear: 'Clear',
    today:'Today',
    yesterday: 'Yesterday',
    checkall: 'Check all',
    searchPlaceHolder:'Please enter a name',
    operators: {
        equal: 'Equal',
        notEqual: 'Not Equal',
        greater: 'Greater Than',
        greaterOrEqual: 'Greater than or equal',
        less: 'Less than',
        lessOrEqual: 'Less than or equal',
        contains: 'Contains',
        notContains: 'Not Contains',
        like: 'Contains',
        notLike: 'Not Contains',
        in: 'In',
        notIn: 'Not In',
        empty: 'Empty',
        notEmpty: 'Not Empty',
        null: 'Null',
        notNull: 'Not Null'
    }
};
